// Plan tier configuration and access helpers
export const PLAN_LEVELS = { none: 0, start: 1, evolution: 2, elite: 3, admin: 99 };

export const PLAN_NAMES = {
  start: "AS START",
  evolution: "AS EVOLUTION",
  elite: "AS ELITE",
};

// Minimum plan level required for each feature
export const REQUIRES = {
  NUTRITION_TEMPLATES: 1,         // START+ : all templates
  NUTRITION_CALCULATOR: 2,        // EVOLUTION+
  NUTRITION_FOODS: 1,             // START+ : food substitution list
  TRAINING: 1,                    // START+ : ALL routines (any level)
  EXERCISE_GUIDE: 1,              // START+ : exercise catalog with techniques
  SUPPLEMENTS_GUIDE: 1,           // START+ : supplements guide with evidence
  TRACKING: 2,                    // EVOLUTION+
  WHATSAPP_TEMPLATES: 99,         // admin only
  LIBRARY: 0,                     // public
};

export function getLevel(user) {
  if (!user) return 0;
  if (user.role === "admin") return 99;
  return user.effective_plan?.level || 0;
}

export function canAccess(user, requiredLevel) {
  return getLevel(user) >= requiredLevel;
}

export function planNameForLevel(level) {
  if (level >= 3) return "AS ELITE";
  if (level >= 2) return "AS EVOLUTION";
  if (level >= 1) return "AS START";
  return "AS START";
}
